<script>
export default {
  components: {},
  props: {
    publicProofId: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      id: this.$A.GetUUID(),
      password: "",
      message: "",
    };
  },
  methods: {
    open: function () {
      this.$bvModal.show(this.id);
    },
    submit: async function () {
      if (this.password.length === 0) {
        this.message = "Please enter the proof password.";
        return;
      }
      let valid = await this.$A.ReviewService.ValidateProofPassword(
        this.$props.publicProofId,
        this.password
      );
      if (!valid) {
        this.message = "That password is incorrect. Please try again.";
        return;
      }
      this.message = "";
      this.$emit("onpasswordvalidated", this.password);
      this.$bvModal.hide(this.id);
    },
    handleKey: function (event) {
      if (event.code === "Enter") {
        return this.submit();
      }
    },
  },
};
</script>
<template>
  <div id="proof-password-gate-modal">
    <b-modal :id="id" size="lg" no-close-on-backdrop no-close-on-esc>
      <template v-slot:modal-header>
        <div class="w-100 text-center">
          <h4>This proof is password protected</h4>
          <p>Enter the password you received to open this proof.</p>
          <div class="form-group">
            <div class="form-item">
              <input
                type="password"
                class="form-control"
                placeholder="Proof password"
                v-model="password"
                data-cy="proofPasswordGateInput"
                autocomplete="off"
                @keyup="handleKey"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="form-item">
              <p style="color: red">{{ message }}</p>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <div class="w-100 d-flex justify-content-end align-items-center">
          <b-button
            class="green-btn"
            data-cy="proofPasswordGateSubmitBtn"
            @click="submit()"
            >Continue</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<style scoped>
.green-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px !important;
  height: 38px;
  background: #019256;
  box-shadow: 0px 1px 2px rgb(8 11 13 / 5%);
  border-radius: 6px;
  font-family: 'Open Sans';
  color: white;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-left: 20px;
}

.green-btn:hover {
  background-color: #019255 !important;
  opacity: 0.9 !important;
  color: white;
}
</style>
